import Vue from 'vue'
import VueRouter from 'vue-router'

import About from "@/components/About.vue"
import Index from "@/components/Index.vue"

import RotatingSolids from "@/components/pages/RotatingSolids.vue"
import Snake from "@/components/pages/Snake.vue"
import OrbitalMechanics from "@/components/pages/OrbitalMechanics.vue"
import ForcesSimulator from "@/components/pages/ForcesSimulator.vue"
import InfinitePolygons from "@/components/pages/InfinitePolygons.vue"
import NPendulum from "@/components/pages/NPendulum.vue"
import MandelbrotExplorer from "@/components/pages/Mandelbrot.vue"
import PokemonNameGen from "@/components/pages/PokemonNameGen.vue"
import CaptchaAttempt from "@/components/pages/CaptchaAttempt.vue"
import DoublePendulum from "@/components/pages/DoublePendulum.vue"

Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', component: Index },
        { path: '/about', component: About },
        { path: '/rotating_solids', component: RotatingSolids },
        { path: '/snake', component: Snake },
        { path: '/orbital_mechanics', component: OrbitalMechanics },
        { path: '/forces_simulator', component: ForcesSimulator },
        { path: '/infinite_polygons', component: InfinitePolygons },
        { path: '/n_pendulum', component: NPendulum },
        { path: '/mandelbrot', component: MandelbrotExplorer },
        { path: '/pokemon', component: PokemonNameGen },
        { path: '/captcha', component: CaptchaAttempt},
        { path: '/double_pendulum', component: DoublePendulum}
    ]
});

export default router;